import RetailFilter from "../../../Components/Filters/RetailFilter.jsx";
import ModalMuiTable from "../../../Components/Modals/ModalMuiTable.jsx";

export const RetailTableDetailed = ({ closeModal }) => {
  return (
    <div>
      <ModalMuiTable
        open={true}
        sliceName={"filters"}
        FilterComponent={RetailFilter}
        heading={"Retail Detailed Report"}
        apiEndpoint={"retails/retails-report"}
        onClose={closeModal}
      />
    </div>
  );
};

export default RetailTableDetailed;
